import React from "react";
import { X } from "lucide-react";
import { Constants } from "../utils/constants";
import HActionButton from "./HActionButton";

const HFormModal = ({
  isOpen,
  onClose,
  title = "Form",
  children,
  primaryActionLabel = "Save",
  secondaryActionLabel = "Cancel",
  onPrimaryAction,
  onSecondaryAction,
  maxHeight,
  primaryActionDisabled = false,
}) => {
  if (!isOpen) return null;

  const handlePrimaryAction = () => {
    if (onPrimaryAction) {
      onPrimaryAction();
    } else {
      onClose();
    }
  };

  const handleSecondaryAction = () => {
    if (onSecondaryAction) {
      onSecondaryAction();
    } else {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div
        className="w-full max-w-md mx-auto bg-white p-6 rounded-xl shadow-xl"
        style={{
          maxHeight: maxHeight || "auto",
          overflow: maxHeight ? "hidden" : "visible",
        }}
      >
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-full flex items-center justify-center text-white transition-colors hover:opacity-90"
            style={{ backgroundColor: Constants.HOST_EXPERIENCE_BASE_COLOR }}
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="space-y-5">
          {children}

          {/* Action Buttons */}
          <div className="flex gap-3">
            <HActionButton label={secondaryActionLabel} variant="outline" fullWidth onClick={handleSecondaryAction} />
            <HActionButton
              label={primaryActionLabel}
              variant="primary"
              fullWidth
              onClick={handlePrimaryAction}
              disabled={primaryActionDisabled}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HFormModal;
